import request from '@/utils/request'

export function login(data) {
  return request({
    url: '/admin/login',
    method: 'post',
    data
  })
}

export function logout() {
  return request({
    url: '/admin/logout',
    method: 'post'
  })
}

export function filterPermission() {
  return request({
    url: '/admin/filter-permission',
    method: 'get'
  })
}

export function list(params) {
  return request({
    url: '/admin/list',
    method: 'get',
    params
  })
}

export function add(data) {
  return request({
    url: '/admin/add',
    method: 'post',
    type: "json",
    data
  })
}

export function edit(data) {
  return request({
    url: '/admin/edit',
    method: 'post',
    type: "json",
    data
  })
}

export function verify(data) {
  return request({
    url: '/admin/verify',
    method: 'post',
    data
  })
}

export function statusEdit(data) {
  return request({
    url: '/admin/status/edit',
    method: 'post',
    type: "json",
    data
  })
}

export function info(params) {
  return request({
    url: '/admin/info',
    method: 'get',
    params
  })
}
